module.exports = __webpack_public_path__ + "static/Depositphotos_165058806_m-2015-328666631be7653b63ee379c41f9aebb.webp";